import { render } from "./cell_tag.vue?vue&type=template&id=6ed824b6"
import script from "./cell_tag.vue?vue&type=script&lang=ts"
export * from "./cell_tag.vue?vue&type=script&lang=ts"
script.render = render

export default script